import { NextFrontasticImage } from '../../../frontastic';

export const isValidFrontasticImage = (image?: NextFrontasticImage): boolean => {
  return !!image?.media;
};
